import React from "react";
import { PerformanceTab, sampleAgent } from "./index";
import { AgentLayout } from "./AgentLayout";

export const PerformancePage: React.FC = () => {
  // In a real app, you would fetch the agent data based on agentId
  const agent = sampleAgent;

  return (
    <AgentLayout activeTab="performance">
      <PerformanceTab agent={agent} />
    </AgentLayout>
  );
};
